import { createSlice } from "@reduxjs/toolkit";

const currencySlice = createSlice({
  name: "currencyDetails",
  initialState: [],
  reducers: {
    setCurrencyDetails: (_state, action) => ({
      ...action.payload,
    }),
  },
});

export const { setCurrencyDetails } = currencySlice.actions;

export const currencyDetails = currencySlice.reducer;

export default currencySlice.reducer;
